"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";

import {
    clearDatadogUser,
    initDatadog,
    setDatadogUser,
} from "@/lib/datadog";

export function DatadogInit() {
    const { data: session, status } = useSession();

    useEffect(() => {
        initDatadog();
    }, []);

    useEffect(() => {
        if (status === "authenticated" && session?.user) {
            setDatadogUser({
                id: session.user.id,
                email: session.user.email,
                name: session.user.name,
            });
        } else if (status === "unauthenticated") {
            clearDatadogUser();
        }
    }, [status, session?.user?.id, session?.user?.email, session?.user?.name]);

    return null;
}
